<template>
	<div class="im-service-ended-panel">
		<section class="im-service-panel-width im-service-ended-panel__main">
			<div class="resize-bar"></div>
			 <div class="resize-line"></div>
			 <div class="resize-save">
				<chatHeader :source="source"/>
				<div class="im-service-ended-panel__box" v-if="lists.length > 0">
					<virtual-list class="list-infinite scroll-touch" 
					  :data-key="'msg_id'"
					  :data-sources="lists"
					  :data-component="itemComponent"
					  :item-class="'list-item-infinite'"
					  v-on:totop="onScrollToTop">
					<div slot="header" class="loading-toobar">
						<el-button @click="toMore()" type="text" :disabled="!isMore" :loading="loading">{{loading ? '加载中...' : isMore ? '加载更多' : '没有更多数据咯'}}</el-button>
					</div>
					</virtual-list>
				</div>
				<el-empty description="暂无数据" v-else></el-empty>
			</div>     
		</section>
		<section class="im-service-ended-panel__control">
			<p class="end_text">已结束</p>
		</section>
	</div>
</template>

<script>
	import chatItem from './chatItem';
	import { chatHeader } from '../common';
	import { getSort, getMutipSort } from '@/utils/functions'
	export default {
		components:{
			chatHeader
		},
		props:['source'],
		data() {
			return {
				itemComponent: chatItem,
				loading:false,
				isMore:false,
				lists:[],
				listQuery:{
					pageNum:1,
					pageSize:10,
					customerId:'',
				},
				totalSize:0,
			}
		},
		watch:{
			'source':{
				handler(data){
					if(Object.keys(data).length > 0) {
						this.listQuery.pageNum = 1;
						this.lists = [];
						this.getData();
						return;
					}
					this.lists = [];
				},
				deep:true
			}
		},
		methods:{
			toMore(){
				this.listQuery.pageNum++;
				if(this.listQuery.pageNum > this.totalSize) {
					this.isMore = false;
					this.listQuery.pageNum = 1;
				}else {
					this.isMore = true;
				}
				this.getData()
			},
			onScrollToTop(){
				if(!this.isMore)return;
				this.toMore();
			},
			getData(){
				this.loading = true;
				this.listQuery.customerId = this.source.sender_id;
				this.$api.getImServiceEndedChat(this.listQuery).then(res => {
					if(res.errcode == 0) {
						this.loading = false
						this.isMore = res.pages > this.listQuery.pageNum;
						let results = res.list.length > 0 ?  this.lists.concat(res.list) : res.list;
						this.lists = results.sort(getMutipSort([
						  getSort((a, b) => a.sendtime < b.sendtime),
						]));
						this.totalSize = res.pages;
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.im-service-ended-panel {
		width: 100%;
		height: 100%;
		display: flex;
		
		&__main {
			position: relative;
			height: calc(100vh - 94px);
			.resize-save {
			    position: absolute;
			    top: 0; 
				right: 5px;
				bottom: 0; 
				left: 0;
			    // padding: 16px;
			    overflow-x: hidden;
			}
			.resize-bar {
			    min-width: 500px;
				max-width: calc(100vw - 600px - 294px - 210px);
				height: calc(100vh - 94px);
			    resize: horizontal;
			    cursor: ew-resize;
			    cursor: col-resize;
			    opacity: 0;
			    overflow: scroll;
			}
			/* 拖拽线 */
			.resize-line {
			    position: absolute;
			    right: 0;
				top: 0;
				bottom: 0;
			    border-right: 1px solid #d8d8d8;
			    pointer-events: none;
			}
			.resize-bar:hover ~ .resize-line,
			.resize-bar:active ~ .resize-line {
			    border-left: 1px dashed #337EFF;
			}
			.resize-bar::-webkit-scrollbar {
				min-width: 500px;
				height: calc(100vh - 94px);
			}
		}
		&__control {
			flex: 1;
			height: 100%;
			padding: 0;
			position: relative;
			overflow: auto;
			display: flex;
			justify-content: center;
			align-items: center;
			.end_text {
				font-size: 14px;
				color: #566980;
				
			}
		}
		
		&__box {
			width: 100%;
			height: calc(100% - 55px);
			box-sizing: border-box;
			padding: 10px;
			position: relative;
			font-size: 14px;
			overflow: hidden;
			box-sizing: border-box;
			.scroll-touch {
				height: 100%;
				overflow-y: auto;
			}
			.loading-toobar {
				height: 30px;
				line-height: 30px;
				display: flex;
				justify-content: center;
			}
		}
	}
</style>